import { ThemeOptions } from '@mui/material';
import type {} from '@mui/x-date-pickers-pro/themeAugmentation';

export const MuiMultiInputDateRangeField: ThemeOptions['components']['MuiMultiInputDateRangeField'] = {
  defaultProps: {
    dateSeparator: ' '
  }
};
